import { getUserThumbnail, calculateRating } from 'data/utils/user';
export const transformClosetUser = user => {
  return {
    id: user.id,
    name: user.login,
    image: getUserThumbnail(user.photo),
    url: user.url,
    rating: calculateRating(user.feedback_reputation),
    ratingCount: user.feedback_count,
    isFollowed: user.is_favourite,
    itemCount: user.item_count
  };
};
export const transformCloset = closet => {
  const {
    items,
    user
  } = closet;
  return {
    user: transformClosetUser(user),
    items,
    showBanner: false
  };
};
export const transformClosets = data => data.map(transformCloset);